import {FormProps, FormState} from '../../@types/components/Form';
import FormWithSubmitActions from './FormWithSubmitActions';
import LoaderOnOverlay from '../LoaderOnOverlay/LoaderOnOverlay';
import {IEmptyModel} from '../../@interfaces/IEmptyModel';

export default class FormWithLoadingIndicator<
    Model extends IEmptyModel = IEmptyModel,
    Props extends FormProps<Model> = FormProps<Model>,
    State extends FormState = FormState
> extends FormWithSubmitActions<Model, Props, State> {
    protected async onSubmit(data: Record<string, any>): Promise<any> {
        this.showLoader();

        return super.onSubmit(data);
    }

    protected async onSubmitRequestCompleted(): Promise<void> {
        this.hideLoader();
    }

    protected showLoader() {
        this.setState({loading: true});
    }

    protected hideLoader() {
        this.setState({loading: false});
    }

    protected getLoadingIndicatorState(): boolean | undefined {
        return this.props.displayLoadingIndicator ?? this.state.loading;
    }

    protected getLoadingIndicator() {
        return LoaderOnOverlay;
    }
}
